import React, { Component } from 'react';
import '../privacy/PrivacyHeader.css';

class ChildSafetyHeader extends Component {
  render() {
    return (
      <div className="PrivacyHeader">
        <div className="background">
          <div className="contents">
            <span className="desc">아동 안전 표준</span>
            <span className="title">LEMONCAKE</span>
          </div>
        </div>
      </div>
    );
  }
}

export default ChildSafetyHeader;
